<template>
    <div class="page-content" v-if="ready">
        <h1>Highlights</h1>
        <p>Analysing your data to highlight improvements to your products performance.</p>
        <hr />
        <feed-list />
    </div>
</template>
<script>
    import { mapActions, mapGetters } from 'vuex'
    import FeedList from '../FeedList.vue'

    export default {
        name: 'FeedView',
        components: {
            'feed-list': FeedList
        },
        data() {
            return {
                ready: false
            }
        },
        computed: {
            ...mapGetters(['user'])
        },
        watch: {
            'user': 'checkAccess'
        },
        created() {
            this.checkAccess()
        },
        methods: {
            ...mapActions(['getInsights']),
            checkAccess() {
                if (this.user && (!this.user.company.hasFeature('Highlights') && !this.user.internalUser)) {
                    this.$router.push('/performance')
                }
                else {
                    this.ready = true
                }
            },
            hideDropDown() {
                this.$emit('hideDropDown')
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../styles/base';

    .page-content {
        max-width: $feed-width;
        margin: 0 auto;
        height: auto;
    }
</style>
